// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"de3b5f59","688":"40f676d2","892":"db4dbc19"}[chunkId] + ".chunk.js";
};